import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {WizardClickEvent} from "../models/events/wizard-click-event";
import {LocalStorageUtils} from "../../infrastructure/utils/local-storage.utils";
import {WIZARD_WIDGET} from "../../widgets/wizard-widget/wizard-widget-consts";

export class WizardClickEventHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  localStorageUtils: LocalStorageUtils;
  type = ACTION_TYPES.wizardClick;

  static injectables = [AnalyticsService, LocalStorageUtils];

  constructor(analyticsService: AnalyticsService, localStorageUtils: LocalStorageUtils) {
    super(analyticsService);

    this.eventType = WizardClickEvent;
    this.localStorageUtils = localStorageUtils;
  }

  async action(params) {
    this.appStore.state.wizardDisplayModel.source = params.source;
    this.sendImportSelectionsEvent(params.page, params.importSource);
    params.isVisible && this._sendEvent(params);
    this._displayWizard(params);
  }

  _sendEvent(params) {
    const currentLinkModelName = this.state.currentLinkModel && this.state.currentLinkModel.name;
    const clickEvent: WizardClickEvent = new WizardClickEvent({
      screen: this.getScreen(currentLinkModelName),
      source: params.source
    });

    this.analyticsService.createEvent(clickEvent);
  }

  _displayWizard(params) {
    this.appStore.state.wizardDisplayModel.page = params.page;
    this.appStore.state.wizardDisplayModel.isVisible = params.isVisible;
  }

  sendImportSelectionsEvent(page, source) {
    if(page === WIZARD_WIDGET.PAGES_TYPES.importSelections) {
      this.controller.action(ACTION_TYPES.wizardImportSelections, {source})
    }
  }
}
